import { Option } from './option.interface';

export const NullOption: Option = {
	value: 'null',
	label: 'None'
};
